import "core-js/modules/es6.string.starts-with";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enEl from 'element-ui/lib/locale/lang/en';
import zhEl from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from '@/i18n/locales/en.js';
import zhLocale from '@/i18n/locales/zh.js';
Vue.use(VueI18n);
export function getBrowserLanguage() {
  var browserLang = navigator.language || navigator.userLanguage || 'en';
  return browserLang;
}
var locale = getBrowserLanguage();
var i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages: {
    en: _objectSpread(_objectSpread({}, enLocale), enEl),
    zh: _objectSpread(_objectSpread({}, zhLocale), zhEl)
  }
});
export function setI18nLanguage(lang) {
  i18n.locale = lang;
}
export function getI18nLanguage() {
  return i18n.locale;
}

// 将浏览器语言转换为接口所需的语言代码
export function getApiLanguageCode() {
  var browserLang = getI18nLanguage() || getBrowserLanguage();

  // 检查是否为中文系语言
  if (browserLang.toLowerCase().startsWith('zh')) {
    return 'zh-cn';
  }

  // 其他所有语言（包括英语系和非中文系语言）都使用 en-us
  return 'en-us';
}
export default i18n;